export const channelItemTypes = {
  COMMENTS: 'comments',
  ATTACHMENTS: 'attachments',
  CHANGESETS: 'changesets',
};

